import { SessionTranscripts } from "../types/supabase";
import { BaseApi } from "./baseApi";

export const sessionTranscriptsApi = new BaseApi<SessionTranscripts>(
  "session_transcripts"
);
